import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { FeeService } from '../../../shared/services/fee.service';
import { LoginService } from '../../../shared/services/login.service';
import { WorkrequestMfbDetails } from '../workrequest-mfb-details';
import { RefDataDropdownComponent } from '../../../shared/components/ref-data-dropdown/ref-data-dropdown.component';
import { RefDataService } from '../../../shared/services/ref-data.service';
import { RefDataType } from '../../../shared/data-objects/ref-data-item';
import * as moment from 'moment';
import * as momentBD from 'moment-business-days';
import { MfbService } from '../mfb.service';

const spaReferenceNumberRE = /^[sS][pP][aA]\/[1-9][0-9]\/[0-9]{5}$/;
const vbaConsentNumberRE = /^[0-9]{11}$/;
const nonWhiteSpaceRE = /[\S]/g;

@Component({
  selector: 'app-workdetials-mfb',
  templateUrl: './workdetails-mfb.component.html',
  styleUrls: ['./workdetails-mfb.component.css']
})
export class WorkdetailsMfbComponent implements OnInit {

  @Input()
  isReadOnly: boolean;

  @ViewChild('meterSizes') zones: RefDataDropdownComponent;
  MeterSizes: any[];

  spaRefNumControl: FormControl;
  vbaConsentNumControl: FormControl;
  preferredVisitDateControl: FormControl;
  meterSizeControl: FormControl;

  today: Date = new Date();
  tomorrow: Date = new Date(this.today.setDate(this.today.getDate() + 1));
  holidays: any;
  minDateForPlumberBooking: Date = new Date();

  constructor(private loginService: LoginService, private feeService: FeeService, private mfbService: MfbService, private refDataService: RefDataService) {
    // this.spaRefNumControl = new FormControl('', [Validators.pattern(spaReferenceNumberRE), Validators.required]);
    this.spaRefNumControl = new FormControl('', []);
    //this.vbaConsentNumControl = new FormControl('', [Validators.pattern(vbaConsentNumberRE), Validators.required]);
    this.vbaConsentNumControl = new FormControl('', []);
    this.preferredVisitDateControl = new FormControl('', [Validators.required]);
    this.meterSizeControl = new FormControl('', [Validators.pattern(nonWhiteSpaceRE), Validators.required]);
  }

  async ngOnInit() {
    await this.retrieveMeterSizes();
    await this.publicHolidays();
  }

  async publicHolidays() {
    try {
      const dtFormat: string = 'YYYY-MM-DD';
      const holidays = await this.refDataService.publicHolidays('mfb', this.loginService.getToken()).toPromise();
      this.holidays = holidays.map((h: any) => new Date(h));

      momentBD.updateLocale('us', { holidays, holidayFormat: dtFormat });

      // check if today is holiday
      const today: string = moment().format(dtFormat);
      const isTodayHoliday: boolean = (holidays.indexOf(today) > -1);
      const leadTime: number = isTodayHoliday ? 3 : 2;

      this.minDateForPlumberBooking = momentBD(moment().format(dtFormat), dtFormat).businessAdd(leadTime)['_d'];

      console.log({ holidays, _holidays: this.holidays });
    } catch (ex) {
      console.log(ex);
    }
  }

  async retrieveMeterSizes() {
    try {
      this.MeterSizes = await this.refDataService.retrieveReferenceData(RefDataType.MFMeterSize, this.loginService.getToken()).toPromise();
      // only send 20mm meter size to DAMS
      this.workDetails.mainMeterSize = this.MeterSizes && this.MeterSizes.find(x => x.display == '20mm') ? this.MeterSizes.find(x => x.display == '20mm').id : '';
    } catch (ex) {
      console.log(ex);
    }
  }

  get yearsRange(): string {
    return '2023:' + (moment().toDate().getFullYear() + 5).toString();
  }

  get workDetails(): WorkrequestMfbDetails {
    return this.mfbService.workrequestDetails;
  }

  get errorMessage(): string {
    return this.workDetails.errorMessage;
  }

  set errorMessage(v: string) {
    this.workDetails.errorMessage = v;
  }

  markAsTouched(): void {
    this.spaRefNumControl.markAsTouched();
    this.vbaConsentNumControl.markAsTouched();
    this.meterSizeControl.markAsTouched();
    this.preferredVisitDateControl.markAsTouched();
  }

  markValidationControlsAsUntouched(): void {
    this.spaRefNumControl.markAsUntouched();
    this.vbaConsentNumControl.markAsUntouched();
    this.meterSizeControl.markAsUntouched();
    this.preferredVisitDateControl.markAsUntouched();
  }

  get invalid(): boolean {
    return (this.spaRefNumControl.invalid
      || this.vbaConsentNumControl.invalid
      || this.preferredVisitDateControl.invalid
      || this.meterSizeControl.invalid)
  }

  displayErrorMessage(): string {
    this.spaRefNumControl.markAsTouched();
    this.vbaConsentNumControl.markAsTouched();
    this.meterSizeControl.markAsTouched();
    this.preferredVisitDateControl.markAsTouched();

    this.errorMessage = null;

    let errorText = '';

    if (this.spaRefNumControl.invalid) {
      if (this.spaRefNumControl.hasError('pattern') || this.spaRefNumControl.hasError('required')) {
        errorText += 'Please enter valid simple plumbing application reference number; e.g SPA/23/01234' + '<br>';
      }
    }

    if (this.vbaConsentNumControl.invalid) {
      if (this.vbaConsentNumControl.hasError('pattern') || this.vbaConsentNumControl.hasError('required')) {
        errorText += 'Please enter valid 11-digit VBA consent number' + '<br>';
      }
    }

    if (this.meterSizeControl.invalid) {
      if (this.meterSizeControl.hasError('pattern') || this.meterSizeControl.hasError('required')) {
        errorText += 'Please choose a meter size.' + '<br>';
      }
    }

    if (this.preferredVisitDateControl.invalid) {
      if (this.preferredVisitDateControl.hasError('required')) {
        errorText += 'Please pick up your preferred date.' + '<br>';
      }
    }

    this.markValidationControlsAsUntouched();

    this.errorMessage = errorText.length > 0 ? errorText : null;
    return errorText;
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/mfb-form/workdetails-mfb/workdetails-mfb.component.ts